import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { ApiResult } from "../../../../types/ApiResult";

export const useSubmitDesign = (
	retailOrderID: number,
	onSuccess: (result: ApiResult) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/submit-design",
				{
					retailOrderID: retailOrderID
				}) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when submitting design packet: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
